<template>
    <div class="couponModel view-userCoupon" :class="{ active: isShow}">
        <div class="couponModel-bg" @click="closeCruiseCoupon()"></div>
        <div class="couponModel-container">
            <div class="couponModel-title">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/giftIcon.png">
                <span>优惠券</span>
            </div>
            <div class="couponModel-con">
                <div class="coupon-itemBody" v-for="(coupon, i) in coupons" :key="i" :class="{ hasSent: coupon.couponState == 2}">

                    <div class="coupon-itemConL">
                        <div class="coupon-itemTypeTxt">{{coupon.promotion}}</div>
                        <div class="coupon-itemExpiryDate">有效期:&nbsp;{{coupon.startTime}}-{{coupon.endTime}}</div>
                        <div class="coupon-itemRule">
                            <span class="coupon-itemRuleTxt useRuleBtn" @click="onCouponRuleClick(coupon.couponRule)">使用规则</span>
                        </div>
                        <div class="js-receiveBtn" data-couponid="112" @click="onGetCouponClick(coupon)"></div>
                    </div>
                </div>
                
               
            </div>
            <div class="couponModel-closed js-closedBtn" @click="closeCruiseCoupon()"><span>X</span></div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "CruiseCoupon",
    props: {
        isShow: {
            type: Boolean
        },
        coupons: {
            type: Array
        },
        closeCruiseCoupon: {
            type: Function
        },
        onCouponRuleClick: {
            type: Function
        },
        setCouponRecieved: {
            type: Function
        }
    },
    methods: {
        async onGetCouponClick(coupon) {
            if (coupon.couponState == 2) {
                return
            }
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                this.$confirm.show('您尚未登录， 请登录之后， 再领取优惠券', {
                    confirmCallBack: () => {
                        this.$router.push({ name: 'Login', query:{ 
                            returnUrl: location.href
                        }})
                    }
                })
                return
            }
            this.$loading.show()
            const { success, errMsg } = await api.booking.giveUserCoupon({
                id: coupon.id,
                source: 'mobile'
            })
            this.$loading.hide()
            if (!success) {
                this.$alert.show(errMsg)
                return
            }
            this.setCouponRecieved(coupon.id)
        }
    }
}
</script>

<style lang="less" scoped>
.couponModel {
    width: 100%;
    height: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1000;
    display: none;
    .couponModel-bg {
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.4);
        position: fixed;
        bottom: 0;
        left: 0;
    }
    .couponModel-container {
        background-color: #fff;
        border-top: 5px solid #FEBC10;
        padding: 22px 20px 30px 20px;
        position: absolute;
        bottom: 0;
        width: 100%;
        padding-bottom: 44px;
        .couponModel-title {
            padding-bottom: 8px;
            border-bottom: 1px solid #CCCCCC;
            img {
                width: 26px;
                vertical-align: middle;
            }
            span {
                display: inline-block;
                vertical-align: middle;
                font-family: PingFang-SC-Medium;
                font-size: 14px;
                color: #4A90E2;
                letter-spacing: 1px;
                margin-left: 5px;
            }
        }
        .couponModel-con {
            margin-top: 12px;
            max-height: 400px;
            overflow-y: scroll;
            .coupon-itemBody {
                margin-bottom: 10px;
                background-color: transparent;
                background-image: url(https://resource.rcclchina.com.cn/tui2/cruise/coupon_get.png);
                background-size: 100% 100%;
                position: relative;
                height: 75px;
                color: #051555;
                .coupon-itemTypeTxt {
                    font-family: PingFangSC-Semibold;
                    font-size: 15px;
                    letter-spacing: 0;
                    margin-left: 10px;
                    position: relative;
                    top: 12px;
                    max-width: 210px;
                    font-weight: 600;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .coupon-itemExpiryDate {
                    font-family: PingFang-SC-Medium;
                    font-size: 11px;
                    margin-left: 10px;
                    margin-top: 12px;
                    letter-spacing: 0;
                }
                .coupon-itemRule {
                    font-family: PingFang-SC-Medium;
                    font-size: 11px;
                    letter-spacing: 0;
                }
                .coupon-itemRuleTxt {
                    margin-left: 10px;
                    margin-right: 10px;
                    margin-top: 2px;
                    text-decoration: underline;
                }
                .js-receiveBtn {
                    position: absolute;
                    width: 106px;
                    height: 75px;
                    background: transparent;
                    top: 0;
                    right: 0;
                }
            }
            .coupon-itemBody.hasSent {
                background-image: url(https://resource.rcclchina.com.cn/tui2/cruise/coupon_has_got.png);
                background-size: 100% 100%;
            }
        }
        .couponModel-closed {
            width: 38px;
            text-align: center;
            height: 34px;
            line-height: 34px;
            position: absolute;
            top: -4px;
            right: -4px;
            background: #FEBC10;
            border-bottom-left-radius: 8px;
            -webkit-border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            -webkit-border-bottom-right-radius: 8px;
            > span {
                display: inline-block;
                color: #fff;
                font-size: 16px;
                -webkit-transform: scale(1.5,1.3);
                -moz-transform: scale(1.5,1.3);
                -ms-transform: scale(1.5,1.3);
                -o-transform: scale(1.5,1.3);
                transform: scale(1.5,1.3);
            }
        }

       
    }
}

.couponModel.active {
    display: block;
}
</style>